<!--update it-->
<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      {{ createNew ? 'New' : 'Edit' }} Dashboard Config 
    </template>
    <template #body>
      <SubSection>              
        <template #body>
          <template v-if="!isSavableStateLoading && selectedConfig">
            <VeeForm @submit="onSubmit">
              <div class="row">
                <TextInput v-model="selectedConfig.name"
                  name="name"
                  label="Name"
                  rules="required"
                  col-style="form-group-standard-column" />

                <MultiSelectInput v-model="selectedConfig.config.status_ids"
                  name="statuses"
                  label="Statuses "
                  :options="superTeamDashboardStore.allStatuses"
                  label-key="name"
                  value-key="id"
                  rules="required"
                  :multiple="true"
                  :show-toggle-all="false"
                  col-style="form-group-standard-column" />
              </div>

              <h3 class="mt-4">
                Manage TxC/Organ Access
              </h3>
              <div class="row">
                <template v-for="(ta, idx) of selectedConfig.config.txc_organs" :key="ta.id">
                  <div class="col-12">
                    <div class="row">
                      <MultiSelectInput v-model="ta.transplant_center_id"
                        name="team-transplant-center"
                        label="Transplant Center"
                        :options="superTeamDashboardStore.allTransplantCenters"
                        label-key="code"
                        value-key="id"
                        col-style="col-md-5" />

                      <MultiSelectInput v-model="ta.organ_group_id"
                        name="team-organ-group"
                        label="Organ Group"
                        :options="superTeamDashboardStore.allOrganGroups"
                        label-key="name"
                        value-key="id"
                        col-style="col-md-5" />
                      <div class="col-md-2">
                        <label aria-hidden="true" class="d-block">&nbsp;</label>
                        <button class="btn btn-danger" @click.prevent="deleteConfig(idx)">
                          <font-awesome-icon :icon="['fas', 'times']" />
                        </button>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="col-12 mt-3 mb-3">
                  <button class="btn btn-primary" @click.prevent="addConfig()">
                    <font-awesome-icon :icon="['fas', 'circle-plus']" />
                    Add New TxC/Organ Access
                  </button>
                </div>
              </div>

              <ActionToolbar :component-state="currentState" 
                :error-message="formError" 
                :success-message="successMessage" 
                :tertiary-enabled="false"
                @secondary-click="cancel"
                :secondary-button-text="createNew ? 'Cancel' : 'Close'"
              />
            </VeeForm>
          </template>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>
<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import SubSection from "@/src/components/shared/SubSection.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import '@/src/vee-validate.js';
import { Form as VeeForm } from 'vee-validate';
import { useTxcStore } from '@/src/stores/transplant_centers';
import {transplantCenterSubSectionNavMixin} from "@/src/components/admin-area/transplant_centers/transplantCenterSubSectionNavMixin";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { FilterMatchMode } from '@primevue/core/api';
import { useSuperTeamDashboardStore } from '@/src/stores/dashboards/super-team-dashboards';
import TextInput from "@/src/components/shared/FormComponents/TextInput.vue";

export default {
  components: {
    CardSection,
    SubSection,
    MultiSelectInput,
    VeeForm,
    ActionToolbar,
    PortalTable,
    Column,
    TextInput
  },
  mixins: [ savableStateMixin , transplantCenterSubSectionNavMixin ],
  setup() {
    const superTeamDashboardStore = useSuperTeamDashboardStore();
    return {
      superTeamDashboardStore
    }
  },
  data() {
    return {
      successMessage: null,
      filterValues: {
        "organ_group_id" : { value: null, matchMode: FilterMatchMode.IN },
      },
      selectedConfig: {
        name: null,
        is_case: null,
        status_ids: null,
        config: {
          txc_organs: []
        }
      }
    }
  },
  computed: {
    createNew() {
      return this.$route.params.id ? false : true;
    },
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      await this.superTeamDashboardStore.loadAllTransplantCentres();
      await this.superTeamDashboardStore.loadAllOrganGroups();
      await this.superTeamDashboardStore.loadAllStatuses();

      if (!this.createNew) {
        const response = await this.superTeamDashboardStore.loadSuperTeamDashboardConfig(this.$route.params.id); 
        this.setSelectedConfig(response)                                                                                                                       
      }
      this.setSavableStateIdle(); 

      
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    async onSubmit() {
      this.setSavableStateProcessing();

      let response;
      const payload = {
        name: this.selectedConfig.name,
        config : { 
          status_ids: this.selectedConfig.config.status_ids,
          txc_organs: this.selectedConfig.config.txc_organs.map(ta => {
            return {
              transplant_center_id: ta.transplant_center_id,
              organ_group_id: ta.organ_group_id
            }
          })
        }
      }

      try {
        if (this.createNew) {
          response = await this.superTeamDashboardStore.createSuperTeamDashboardConfig(payload);
          this.setSavableStateSuccess();
          this.successMessage = 'Successfully created config!'
          this.$router.push({name: 'admin_super-team-dashboards_edit', params: {id: response.id}});
        } 
        else {
          payload.id =this.selectedConfig.id,
          response = await this.superTeamDashboardStore.updateSuperTeamDashboardConfig(payload);
          this.setSavableStateSuccess();
          this.successMessage = 'Successfully updated config!'
        } 
        this.setSelectedConfig(response);
      }catch(error) {
        this.handleFormError(error)
      }
    },
    setSelectedConfig(record) {
      this.selectedConfig = {
        id: record.id,
        name: record.name,
        config: record.config,
      }
    },
    cancel() {
      this.$router.push({ name: 'admin_super_team_dashboards' });
    },
    addConfig() {
      this.selectedConfig.config.txc_organs[this.selectedConfig.config.txc_organs?.length || 0] = {
        id: this.selectedConfig.config.txc_organs?.length || 0,
        transplant_center_id: null,
        organ_group_id: null
      };
    },
    deleteConfig(idx) {
      const txc = this.superTeamDashboardStore.allTransplantCenters.find((t) => t.id === this.selectedConfig.config.txc_organs[idx].transplant_center_id);
      const og = this.superTeamDashboardStore.allOrganGroups.find((o) => o.id === this.selectedConfig.config.txc_organs[idx].organ_group_id);

      if(txc && og && !confirm(`Are you sure you want to delete this txc/organ group access (Transplant center:${txc.code} - Organ group:${og.name}) ?`)) {
        return;
      }

      this.selectedConfig.config.txc_organs.splice(idx, 1);
    },
  }
}
</script>
